// Global
import {
  GetStaticComponentProps,
  withDatasourceCheck,
  Text,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { useState } from 'react';
import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import { mapItemFieldResultsToObject } from 'lib/graphql/mappers/map-item-field-results-to-object';
import { mapSearchResults } from 'lib/graphql/mappers/map-search-results';
import { IntegratedGraphQlResult } from 'lib/graphql/types/integrated-graphql-result';
import { ItemFieldResult } from 'lib/graphql/types/item-field-result';
import { ItemSearchResults } from 'lib/graphql/types/item-search-results';
// Components

//import { AWFooterTheme } from './AWFooter.theme';
import LinkWrapper from 'src/helpers/LinkWrapper/LinkWrapper';
import SvgIcon from 'src/helpers/SvgIcon/SvgIcon';
import ImageWrapper from 'src/helpers/Media/ImageWrapper';
import { useCurrentScreenType } from 'lib/utils/get-screen-type';
import { getEnum } from 'lib/utils/get-enum';
import useExperienceEditor from 'lib/utils/use-experience-editor';

function footerConsentTrigger() {
  if ((window as any)?.truste) {
    (window as any).truste.eu.clickListener();
  }
}

export type AWFooterProps = Feature.EnterpriseWeb.AndersenWindows.Components.Navigation.AWFooter;
const AWFooter = (props: AWFooterProps) => {
  const { fields } = props;
  const isEE = useExperienceEditor();
  const { screenType } = useCurrentScreenType();
  const isDesktop = screenType !== 'sm' && screenType !== 'md' ? true : false;

  const currentYear = new Date().getFullYear().toString();
  const copyrightText = fields?.copyright?.value;
  let textWithReplacedYear = copyrightText;
  if (copyrightText?.includes('{currentYear}')) {
    textWithReplacedYear = copyrightText.replace('{currentYear}', currentYear);
  }

  const navGroup = fields?.children;
  const socialMenu =
    navGroup?.length &&
    navGroup.filter(function (nav: AWFooterProps) {
      return nav?.fields?.menuTitle?.value === 'socialMenu';
    });
  const footerMenu =
    navGroup?.length &&
    navGroup.filter(function (nav: AWFooterProps) {
      return nav.fields?.menuTitle?.value === 'footerMenu';
    });
  const privacyMenu =
    navGroup?.length &&
    navGroup.filter(function (nav: AWFooterProps) {
      return nav.fields?.menuTitle?.value === 'privacyMenu';
    });
  let privacyMenuArray = privacyMenu?.length && privacyMenu[0].fields.children;
  let socialMenuArray = socialMenu?.length && socialMenu[0].fields.children;
  const footerMenuArray = footerMenu?.length && footerMenu[0].fields.children;
  if (socialMenuArray == 0) {
    socialMenuArray = null;
  }
  if (privacyMenuArray == 0) {
    privacyMenuArray = null;
  }

  const Accordion = ({ title, children }: AWFooterProps) => {
    const [isOpen, setOpen] = useState(false);
    return (
      <div>
        <div
          className={`border-t border-solid border-t-white py-xs ${
            isOpen
              ? 'open [&_span]:after:-rotate-90 [&_span]:after:transition-all [&_span]:after:duration-[0.1s]'
              : '[&_span]:after:rotate-90 [&_span]:after:transition-all [&_span]:after:duration-[0.1s]'
          }`}
          onClick={() => setOpen(!isOpen)}
        >
          <span className="flex items-center justify-between text-small font-heavy uppercase leading-[14px] after:text-base after:content-['\276F'] ml:text-xxs ">
            {title}
          </span>
        </div>
        <div
          className={`accordion-item ${
            !isOpen
              ? 'collapsed max-h-0 transition-[max-height] duration-[0.35s] ease-[cubic-bezier(0,1,0,1)]'
              : 'h-auto max-h-[9999px] overflow-hidden transition-[max-height] duration-[0.3s] ease-[cubic-bezier(1,0,1,0)]'
          }`}
        >
          <div>{children}</div>
        </div>
      </div>
    );
  };

  if (!fields) {
    return null;
  }

  return (
    <div
      data-component="site/awfooter"
      className="awfooter bg-black py-m text-base text-white ml:py-l"
    >
      <div className="px-m ml:max-w-screen-lg lg:mx-auto">
        <div className="flex flex-col flex-wrap ml:flex-row">
          <div className="flex flex-col max-ml:order-4 max-ml:mt-l ml:w-[16.6%] ml:basis-[16.6%] ml:pr-xxs">
            <div className="mb-s font-sans text-xs font-heavy uppercase max-ml:hidden ">
              <Text tag={'h3'} field={fields.tagLine} />
            </div>
            <div className="mb-s text-body max-ml:order-2">
              <Text field={{ value: textWithReplacedYear }} />
            </div>
            <div className="flex flex-wrap max-ml:order-1 max-ml:mb-s">
              {socialMenuArray &&
                socialMenuArray.map((menu: AWFooterProps, index: number) => {
                  return (
                    menu.fields?.navItemLink.value &&
                    getEnum(menu.fields?.navItemIcon) && (
                      <div key={index} className="mr-xxs mt-xxxs">
                        {isEE ? (
                          <SvgIcon icon={getEnum(menu.fields?.navItemIcon)} />
                        ) : (
                          <LinkWrapper ctaSection="footer" field={menu.fields?.navItemLink}>
                            <SvgIcon icon={getEnum(menu.fields?.navItemIcon)} />
                          </LinkWrapper>
                        )}
                      </div>
                    )
                  );
                })}
            </div>
          </div>
          <div className="flex flex-col max-ml:order-1 ml:w-[83.4%] ml:basis-[83.4%] ml:pl-xxs">
            <div className="mb-l font-sans text-sm-s font-heavy uppercase ml:hidden">
              <Text tag={'h3'} field={fields.tagLine} />
            </div>
            <div className="flex w-full max-ml:flex-col max-ml:border-b max-ml:border-solid max-ml:border-b-white ml:shrink ml:grow ml:basis-0">
              {footerMenuArray &&
                footerMenuArray.map((menu: AWFooterProps, index: number) => {
                  return (
                    <div key={index} className="flex flex-col ml:w-[20%] ml:pr-xxs">
                      {isDesktop ? (
                        <>
                          <div className="mb-xxxs font-sans text-xxs font-heavy uppercase leading-none">
                            <Text tag={'span'} field={menu.fields?.navGroupTitle} />
                          </div>
                          <ul className={`flex flex-col`}>
                            {menu.fields?.children.map((nav: AWFooterProps, index: number) => {
                              return (
                                nav.fields?.navItemLink && (
                                  <li key={index} className="py-xxxs">
                                    <LinkWrapper
                                      ctaSection="footer"
                                      field={nav.fields?.navItemLink}
                                      className="text-body hover:underline"
                                    >
                                      {nav.fields?.navItemLink.value.target === '_blank' && (
                                        <SvgIcon icon="new-tab" className="ml-xxxs inline-flex" />
                                      )}
                                    </LinkWrapper>
                                  </li>
                                )
                              );
                            })}
                          </ul>
                        </>
                      ) : (
                        <Accordion title={menu.fields?.navGroupTitle.value as string}>
                          {menu.fields && menu.fields.children.length && (
                            <ul className={`ease flex flex-col  transition-all duration-1000`}>
                              {menu.fields?.children.map((nav: AWFooterProps, index: number) => {
                                return (
                                  nav.fields?.navItemLink && (
                                    <li key={index} className="py-xxxs ">
                                      <LinkWrapper
                                        ctaSection="footer"
                                        field={nav.fields?.navItemLink}
                                        className="text-small hover:underline"
                                      >
                                        {nav.fields?.navItemLink.value.target === '_blank' && (
                                          <SvgIcon icon="new-tab" className="ml-xxxs inline-flex" />
                                        )}
                                      </LinkWrapper>
                                    </li>
                                  )
                                );
                              })}
                            </ul>
                          )}
                        </Accordion>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>

          <div className="mt-l flex flex-col max-ml:order-3 max-ml:mb-l ml:w-[16.6%] ml:basis-[16.6%] ml:pr-xxs">
            {fields?.logoCTA?.value?.href !== '' ? (
              <LinkWrapper ctaSection="footer" field={fields.logoCTA}>
                <ImageWrapper
                  image={fields.logo}
                  additionalMobileClasses="max-w-[120px]"
                  additionalDesktopClasses="max-w-[120px]"
                />
              </LinkWrapper>
            ) : (
              <ImageWrapper
                image={fields.logo}
                additionalMobileClasses="max-w-[120px]"
                additionalDesktopClasses="max-w-[120px]"
              />
            )}
          </div>
          <div className="mt-l flex flex-col max-ml:order-3 ml:w-[83.4%] ml:basis-[83.4%] ml:pl-xxs">
            <div className="mb-s flex w-full text-body ml:mb-xxs">
              <Text tag={'h3'} field={fields.privacyCaption} />
            </div>
            <div className="w-full flex-wrap max-ml:text-body md:flex">
              {privacyMenuArray &&
                privacyMenuArray.map((menu: AWFooterProps, index: number) => {
                  return (
                    menu.fields?.navItemLink && (
                      <span key={index}>
                        <LinkWrapper
                          ctaSection="footer"
                          className="text-body underline"
                          field={menu.fields?.navItemLink}
                        >
                          {menu.fields?.navItemLink.value.target === '_blank' && (
                            <SvgIcon icon="new-tab" className="ml-xxxs inline-flex" />
                          )}
                        </LinkWrapper>
                        {index < privacyMenuArray.length - 1 && (
                          <span className="inline-flex md:px-xxxs"> | </span>
                        )}
                      </span>
                    )
                  );
                })}
            </div>
            <button className="flex underline" onClick={footerConsentTrigger}>
              Cookie Preferences
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

type IntegratedGraphQl = IntegratedGraphQlResult<{
  item: {
    fields: ItemFieldResult[];
    children: ItemSearchResults<{
      template: { name: string };
      fields: ItemFieldResult[];
      children: ItemSearchResults<{
        template: { name: string };
        fields: ItemFieldResult[];
        children: ItemSearchResults<{
          template: { name: string };
          fields: ItemFieldResult[];
        }>;
      }>;
    }>;
  };
}>;

export const getStaticProps: GetStaticComponentProps = async (rendering) => {
  if (rendering.fields === undefined || !('data' in rendering.fields)) {
    return {};
  }
  const fields = rendering.fields as unknown as IntegratedGraphQl;

  const result = {
    fields: {
      ...mapItemFieldResultsToObject(fields.data.item.fields),
      children: mapSearchResults(fields.data.item.children, (child1) => ({
        templateName: child1.template.name,
        fields: {
          ...mapItemFieldResultsToObject(child1.fields),
          children: mapSearchResults(child1.children, (child2) => ({
            templateName: child2.template.name,
            fields: {
              ...mapItemFieldResultsToObject(child2.fields),
              children: mapSearchResults(child2.children, (child3) => ({
                templateName: child3.template.name,
                fields: {
                  ...mapItemFieldResultsToObject(child3.fields),
                },
              })),
            },
          })),
        },
      })),
    },
  };

  return result;
};

export default withDatasourceCheck()<AWFooterProps>(AWFooter);
